export const SEND_NOTIFICATION: string = "SEND_NOTIFICATION";
export const GET_NOTIFICATIONS: string = "GET_NOTIFICATIONS";

export const SET_NOTIFICATIONS: string = "SET_NOTIFICATIONS";
